/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BankItemExplainDto } from "./BankItemExplainDto";
import type { BankViewerChoiceDto } from "./BankViewerChoiceDto";
import type { BankViewerFigureDto } from "./BankViewerFigureDto";
export type BankViewerItemDto = {
  id: string;
  /**
   * 문항 key — 틀@seed
   */
  key: string;
  seed: number;
  engineVersion: string;
  /**
   * 'latex' 면 글이 $…$ 수식 글(앱과 같은 글)
   */
  textFormat: BankViewerItemDto.textFormat | null;
  prompt: string;
  /**
   * 〈보기〉 글
   */
  bogi: string | null;
  /**
   * 표 — 첫 행은 머리글
   */
  table: Array<any[]> | null;
  figure: BankViewerFigureDto | null;
  /**
   * 비면 단답형
   */
  choices: Array<BankViewerChoiceDto>;
  /**
   * 선지형 정답 위치(0부터)
   */
  answerIndex: number | null;
  /**
   * 단답형 정답 글
   */
  answerText: string | null;
  /**
   * 풀이 — 새 해설이 있으면 전략·단계·검산을 줄로 이은 글
   */
  explanation: string | null;
  /**
   * 칸으로 나눈 새 해설(엔진 v1.0.8~ 전략·단계·검산), 없는 문항은 null
   */
  explain: BankItemExplainDto | null;
};
export namespace BankViewerItemDto {
  /**
   * 'latex' 면 글이 $…$ 수식 글(앱과 같은 글)
   */
  export enum textFormat {
    LATEX = "latex",
  }
}
